/**
 * One-time notice: this device now keeps a readable copy of what you open.
 *
 * Shown the first time the offline layer caches anything for the account; the
 * offline module records that in its per-account meta so it never shows again
 * on this device. Dismissed with a visible button, never a keyboard shortcut.
 */

import React, { useEffect, useState } from 'react';

import { subscribeToFirstCacheWrite } from '@shared/offline';

/** The strip itself; renders nothing until the offline layer's first write. */
export const OfflineNotice: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeToFirstCacheWrite(() => setVisible(true)), []);

  if (!visible) return null;
  return (
    <div
      role="status"
      className="bg-muted text-foreground border-border flex items-center gap-3 border-b px-3 py-1.5 text-sm"
    >
      <span>
        This device now keeps a readable copy of what you open, so it works without a connection.
        Remove it any time in Profile → Offline.
      </span>
      <button
        type="button"
        onClick={() => setVisible(false)}
        className="bg-background hover:bg-background/80 text-foreground ml-auto rounded-md px-2 py-0.5 text-xs transition-colors"
      >
        Got it
      </button>
    </div>
  );
};
